import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import ApexTree from 'apextree'
import { ToastrService } from 'ngx-toastr';
import { OptionsModalEnum } from 'src/app/common/options-modal';
import { AdminAreaRequest } from 'src/app/models/area.model';
import { AdminDepartmentRequest } from 'src/app/models/department.model';
import { LocationResponse } from 'src/app/models/location.model';
import { AdminPositionRequest } from 'src/app/models/position-role.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HumanResourcesService } from 'src/app/services/human-resources.service';
import { RolesAndPermissionsService } from 'src/app/services/roles-and-permissions.service';

@Component({
  selector: 'app-jobs',
  templateUrl: './jobs.component.html',
  styleUrls: ['./jobs.component.scss']
})
export class JobsComponent implements OnInit {
  typeCreate = '0';
  areas = [];
  locationSelected = '0';
  departments = [];
  positions = [];
  areasObject: { [key: number]: any } = {};
  departmentsObject: { [key: number]: any } = {};
  positionsObject: { [key: number]: any } = {};
  createLocation = false;
  locations: LocationResponse[] = [];
  createArea = false;
  options = OptionsModalEnum;
  temporalQuestion = null;
  tempAreaCreate: AdminAreaRequest = null;
  tempDepartmentEdit: AdminDepartmentRequest = null;
  tempPositionEdit: AdminPositionRequest = null;
  createDepartment = false;
  createPosition = false;

  constructor(
    private roleService: RolesAndPermissionsService,
    private rrhhService: HumanResourcesService,
    private toastService: ToastrService
  ) {

  }

  create() {
    switch (this.typeCreate) {
      case '0': {
        this.tempAreaCreate = new AdminAreaRequest();
        this.createArea = true;
        break;
      }
      case '1': {
        this.tempDepartmentEdit = new AdminDepartmentRequest();
        this.createDepartment = true;
        break;
      }
      case '2': {
        this.tempPositionEdit = new AdminPositionRequest();
        this.createPosition = true;
        break;
      }
      case '3': {
        this.createLocation = true;
        break;
      }
      default:
        break;
    }
  }

  realizarLlamadasSecuenciales() {
    document.getElementById('svg-tree').innerHTML = "";
    this.roleService.getAreas().subscribe(
      (areas: ResponseObject) => {
        this.areas = areas.data;
        this.areas.forEach((a) => {
          a['departments'] = [];
          a['collapsed'] = false;
          this.areasObject[a.id] = a;
        })
        this.roleService.getDepartments().subscribe(
          (departments: ResponseObject) => {
            this.departments = departments.data;
            this.departments.forEach((d) => {
              d['positions'] = [];
              d['collapsed'] = false;
              if (d.area) {
                this.areasObject[d.area]['departments'].push(d);
                this.departmentsObject[d.id] = d;
              }
            });
            this.roleService.getPositions().subscribe(
              (positions: ResponseObject) => {
                this.positions = positions.data;
                this.positions.forEach((p) => {
                  this.departmentsObject[p.department]['positions'].push(p);
                  this.positionsObject[p.id] = p;
                })
                this.drawTree();
                this.putClickEvents();
              },
              error => {
                console.error('Error en getPositions:', error);
              }
            );
          },
          error => {
            console.error('Error en getDepartments:', error);
          }
        );
      },
      error => {
        console.error('Error en getAreas:', error);
      }
    );
  }

  putClickEvents() {

    const editIcons = document.getElementsByClassName('edit-node');
    for (let i = 0; i < editIcons.length; i++) {
      editIcons[i].addEventListener('click', (event: any) => {
        const iconId = event.currentTarget.id;
        var parts = iconId.split("-");
        switch (parts[1]) {
          case "Area":
            this.editArea(this.areasObject[parts[0]]);
            break;
          case "Departamento":
            this.editDepartment(this.departmentsObject[parts[0]]);
            break;
          case "Puesto":
            this.editPosition(this.positionsObject[parts[0]]);
            break;
          default:
            break;
        }
      });
    }
    const deleteIcons = document.getElementsByClassName('delete-node');
    for (let i = 0; i < deleteIcons.length; i++) {
      deleteIcons[i].addEventListener('click', (event: any) => {
        const iconId = event.currentTarget.id;
        var parts = iconId.split("-");
        switch (parts[1]) {
          case "Area":
            this.deleteArea(this.areasObject[parts[0]]);
            break;
          case "Departamento":
            this.deleteDepartment(this.departmentsObject[parts[0]]);
            break;
          default:
            break;
        }
      });
    }

    const collapseNodes = document.getElementsByClassName('collapse-node');
    for (let i = 0; i < collapseNodes.length; i++) {
      collapseNodes[i].addEventListener('click', (event: any) => {
        const iconId = event.currentTarget.id;
        var parts = iconId.split("-");
        document.getElementById("svg-tree").innerHTML = "";
        switch (parts[1]) {
          case "Area":
            this.areasObject[parts[0]]['collapsed'] = !this.areasObject[parts[0]]['collapsed'];
            this.drawTree();
            this.putClickEvents();
            break;
          case "Departamento":
            this.departmentsObject[parts[0]]['collapsed'] = !this.departmentsObject[parts[0]]['collapsed'];
            this.drawTree();
            this.putClickEvents();
            break;
          default:
            break;
        }
      });
    }
  }

  drawTree() {
    var childrens = [];
    this.areas.forEach((a) => {
      var temp = {
        id: a.id,
        data: {
          name: a.name,
          type: 'Area',
          delete: true,
          edit: true,
          collapse: true,
          collapsed: a['collapsed'],
          id: a.id
        },
        options: {
          nodeBGColor: '#94ddff',
        },
        children: []
      }
      this.areasObject[a.id]['departments'].forEach((d) => {
        var tempDepartment = {
          id: d.id,
          data: {
            name: d.name,
            type: 'Departamento',
            delete: true,
            edit: true,
            collapse: true,
            collapsed: d['collapsed'],
            id: d.id
          },
          options: {
            nodeBGColor: '#ffc7c2',
          },
          children: []
        }
        this.departmentsObject[d.id]['positions'].forEach((p) => {
          var tempPosition = {
            id: p.id,
            data: {
              name: p.name,
              type: 'Puesto',
              delete: false,
              edit: true,
              collapse: false,
              collapsed: false,
              id: p.id
            },
            options: {
              nodeBGColor: 'skyblue',
            },
            children: []
          }
          if (!d['collapsed'])
            tempDepartment.children.push(tempPosition);
        });
        if (!a['collapsed'])
          temp.children.push(tempDepartment);
      })
      childrens.push(temp);
    })
    const data = {
      id: 'location',
      data: {
        name: this.getNameLocation(),
        type: 'Ubicación',
        delete: false,
        edit: false,
        collapse: false,
        collapsed: false,
        id: 0
      },
      options: {
        nodeBGColor: '#001f54',
        nodeBGColorHover: '#001f54'
      },
      children: childrens
    };
    const options = {
      contentKey: 'data',
      width: '100%',
      height: 500,
      nodeWidth: 150,
      nodeHeight: 70,
      childrenSpacing: 70,
      siblingSpacing: 30,
      direction: 'left',
      highlightOnHover: false,
      nodeTemplate: (content) => {
        return `<div style='display: flex;flex-direction: row;justify-content: space-between;align-items: center;height: 100%; box-shadow: 1px 2px 4px #ccc; padding: 0 7px;'>
        <div style="position:relative;">
        <b style="color:${(content.type == 'Ubicación') ? 'white' : 'black'};font-weight: bold; font-family: Arial; font-size: 1em; position:fixed; top:5%; left:5%;">${content.name}
        </b>
        <span style="color:gray; position:fixed; bottom:5%; right:5%;">
        ${(content.delete) ? '<i id="' + content.id + '-' + content.type + '" class="text-danger delete-node clickeable fa fa-trash"></i>' : ''}
        ${(content.edit) ? '<i id="' + content.id + '-' + content.type + '" class="text-success edit-node clickeable fa fa-edit"></i>' : ''}
        ${(content.type == 'Ubicación') ? '<i class="fa fa-map-location"></i>' : ''}${content.type}</span>
        </div>
        ${(content.collapse) ? '<span id="' + content.id + '-' + content.type + '" style="position:fixed; top:35%; right: 0px;" class="collapse-node"><i class="fa ' + ((content.collapsed) ? 'fa-circle-plus' : 'fa-circle-minus') + '"></i></span>' : ''}
       </div>`;
      },
      nodeStyle: 'box-shadow: -3px 6px 8px -5px rgba(0,0,0,0.31)',
      canvasStyle: 'background: transparent;',
    };
   // const tree = new ApexTree(document.getElementById('svg-tree'), options);
   // tree.render(data);
  }

  getNameLocation() {
    for (let i = 0; i < this.locations.length; i++) {
      const location = this.locations[i];
      if (location.id+"" == this.locationSelected){
        return location.name;
      }
    }
    return "";
  }

  editPosition(p) {
    this.tempPositionEdit = new AdminPositionRequest();
    this.tempPositionEdit.department = p.department;
    this.tempPositionEdit.id = p.id;
    this.tempPositionEdit.name = p.name;
    this.tempPositionEdit.superior = p.superior;
    this.createPosition = false;
  }

  editDepartment(d) {
    this.tempDepartmentEdit = new AdminDepartmentRequest();
    this.tempDepartmentEdit.area = d.area;
    this.tempDepartmentEdit.head = d.head;
    this.tempDepartmentEdit.name = d.name;
    this.tempDepartmentEdit.id = d.id;
    this.createDepartment = false;
  }

  editArea(a) {
    this.tempAreaCreate = new AdminAreaRequest();
    this.tempAreaCreate.name = a.name;
    this.tempAreaCreate.warehouse = a.location;
    this.tempAreaCreate['id'] = a.id;
    this.createArea = false;
  }

  deleteArea(a) {
    this.temporalQuestion = {
      question: '¿Estás seguro de eliminar el área?',
      title: 'Eliminar area',
      options: [this.options.CANCEL, this.options.DELETE],
      type: 'area',
      id: a.id
    }
  }

  closeOptionModal(selected: any, type: string) {
    switch (type) {
      case 'area': {
        if (selected == this.options.DELETE) {
          var areaId = this.temporalQuestion.id;
          this.rrhhService.deleteArea(areaId).subscribe({
            next: (response: ResponseObject) => {
              this.toastService.success("Area eliminada correctamente");
              this.realizarLlamadasSecuenciales();
              this.temporalQuestion = null;
            },
            error: (error: HttpErrorResponse) => {
              this.toastService.error(error.error.message);
            }
          })
        } else {
          this.temporalQuestion = null;
        }
        break;
      }
      case 'departamento': {
        if (selected == this.options.DELETE) {
          this.toastService.info("Opcion aún en desarrollo");
        } else {
          this.temporalQuestion = null;
        }
        break;
      }
      default: {
        break;
      }
    }
  }

  deleteDepartment(d) {
    this.temporalQuestion = {
      question: '¿Estás seguro de eliminar el departamento?',
      title: 'Eliminar departamento',
      options: [this.options.CANCEL, this.options.DELETE],
      type: 'departamento',
      id: d.id
    }
  }

  ngOnInit(): void {
    this.realizarLlamadasSecuenciales();
    this.rrhhService.getLocations().subscribe({
      next: (response: ResponseObject) => {
        this.locations = response.data;
        var temporalLocation = new LocationResponse();
        temporalLocation.id = 0;
        temporalLocation.name = "Todas";
        this.locations.unshift(temporalLocation);
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    })
  }

  changeSelected(event: any) {
    if (event != '0') {
      this.rrhhService.getAreasByWarehouse(event).subscribe({
        next: (response: ResponseObject) => {
          console.log(response.data);
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(error.error.message);
        }
      })
    } else {
      this.realizarLlamadasSecuenciales();
    }
  }

  closingEditorArea(event) {
    this.tempAreaCreate = null;
    this.createArea = false;
    if (event) {
      this.realizarLlamadasSecuenciales();
    }
  }

  closingEditorDepartment(event) {
    this.tempDepartmentEdit = null;
    this.createDepartment = false;
    if (event) {
      this.realizarLlamadasSecuenciales();
    }
  }
  
  closingEditorPosition(event) {
    this.tempPositionEdit = null;
    this.createPosition = false;
    if (event) {
      this.realizarLlamadasSecuenciales();
    }
  }
}
